import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from 'vue'
import { Alarm, AlarmClient, AreaOfInterest, DTSChart } from '@/server/MakeSenseApp-backend'
import DTSChartComponent from '../DTSChart.vue'
import { useProjectStore } from '@/stores/ProjectStore'
import { requiredInject } from '@/utilities/requiredInject'


export default /*@__PURE__*/_defineComponent({
  __name: 'AlarmDTSChart',
  props: {
  alarm: Alarm
},
  setup(__props) {

const props = __props

const chartData = ref<DTSChart | undefined>(undefined)
const areaOfInterest = ref<AreaOfInterest | undefined>(undefined)
let store = useProjectStore()

onMounted(() => {
  const alarmClient = requiredInject<AlarmClient>('AlarmClient')

  if (props.alarm === undefined || props.alarm.id === undefined) {
    console.error('Alarm ID is undefined')
    return
  }

  alarmClient.dtsForAlarm(store.projectId, props.alarm.id).then((data) => {
    chartData.value = data as DTSChart
    areaOfInterest.value = data.areaOfInterest
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createElementVNode("h5", null, "Distributed Temperature Sensing (DTS)", -1)),
    _createVNode(DTSChartComponent, {
      data: chartData.value,
      areaOfInterest: areaOfInterest.value
    }, null, 8, ["data", "areaOfInterest"])
  ]))
}
}

})